const content: { [key: string]: any } = {
  pageTitle: "Frontline Q+",
  bannerTile: {
    description:
      "Earn a Frontline Q (FQ) each month for every in-market frontline ABO who qualified at the {performanceBonus} Performance Bonus level. Increase or maintain your total FQs each year to earn more.",
    potentialEarnings: "Potential PY{performanceYear} Earnings",
    manuallyApproved: "The Frontline Q+ has been manually approved",
    contactCustomerService: "If you require more information, please contact Customer Support for further details.",
    held: "Your award is on hold.",
    denied: "Your PY{performanceYear} business is not eligible for the Frontline Q+ Incentive.",
    newPY: "The year ahead belongs to you",
    newPYDesc:
      "Happy new Performance Year! Information for the new performance year is coming soon. Updated information will become available when last performance year's baselines have been confirmed.",
  },
  requirements: {
    sectionHeader: "How do I qualify? Track your progress.",
    badgeRequirement: {
      title: "Qualified Founder's Platinum Pin or Above",
      pinLevelLabel: "PY{performanceYear} Pin Level",
      pinTrackingLevelLabel: "Pin Tracking Level",
      inMarketPinLabel: "PY{performanceYear} In Market Pin",
      inMarketPinTrackingLabel: "In Market Pin Tracking",
      achieved: "Achieved",
      onTrack: "On Track",
      notTracking: "Not Tracking",
    },
    q1qvRequirement: {
      title: "1 In-Market Frontline Q",
      section1Title: "PY{pvVal} Baseline",
      section2Title: "Current YTD",
      section3Title: "Tracking",
    },
    previousPYModal: {
      title: "Previous Performance Year",
      amount: "{amountFQs} FQs",
    },
    currentPYModal: {
      title: "Current YTD",
      amount: "{amountFQs} FQs",
    },
    volumeRequirement: {
      title: "{volume} Annual PPV",
      qualified: "Congrats, you've achieved your Annual PPV requirement!",
      onTrack: "You're on track to meet the Annual PPV requirement.",
      notTracking: "You're not tracking to meet the Annual PPV requirement.",
      monthlyPPVTracker: "{monthActualPPV}/{monthActualTarget} Monthly PPV Tracker (Through {monthName})",
      montlyPPVDesc:
        "To stay on track to earn {targetPPV} PPV in PY{currentPy}, your target is {monthlyTarget} PPV per month. Use the donut chart to see how you're tracking each month.",
      legend: {
        monthlyTarget: "Monthly Target",
        onTrack: "On Track",
        belowTarget: "Below Target",
      },
      monthInCircle: "{currentMonth}",
      valsInCircle: "<1>{actualPPV}</1>/{targetPPV}",
    },
  },
  paymentDetails: {
    sectionTitle: "View your Potential Payment Details.",
    tableTitle: "Payment Unit Details",
    pinLevelColumnLabels: {
      pinLevel: "Pin Level",
      foundersPlatinumToFoundersSapphire: "F. PT-F. SAP",
      emeraldToFoundersEmerald: "EME-F. EME",
      diamondToFoundersDiamond: "DIA-F. DIA",
      gar: "GAR",
    },
    FQPerformanceRowLabels: {
      grow: "Grow FQs",
      maintain: "Maintain FQs",
      decline: "Decline FQs",
    },
    incentiveCalc: {
      title: "Incentive Calculation",
      trackingFrontlineQs: "Tracking Frontline Qs",
      paymentUnit: "Payment Unit",
      potentialEarnings: "Potential Frontline Q+ Earnings",
    },
  },
};

export default content;
